import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/restaurants-menus-item',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/menus-item',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
      {
        srcPath: '/restaurants/menus/v1/items',
        destPath: '/v1/items',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemRestaurantsDuplicateItemUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/restaurants-menus-item',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/menus-item',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
      {
        srcPath: '/restaurants/menus/v1/items',
        destPath: '/v1/items',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-item',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_items';

export function duplicateItem(payload: object): RequestOptionsFactory<any> {
  function __duplicateItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.restaurants_duplicate_item.RestaurantsDuplicateItem.DuplicateItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsDuplicateItemRestaurantsDuplicateItemUrl(
        { protoPath: '/v1/items/{id}/duplicate', data: payload, host }
      ),
      data: payload,
    };

    return metadata;
  }

  return __duplicateItem;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates an item.
 *
 * To create multiple items at once, use [Bulk Create Items](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-create-items).
 */
export function createItem(payload: object): RequestOptionsFactory<any> {
  function __createItem({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'item.createdDate' },
          { path: 'item.updatedDate' },
          { path: 'item.image.urlExpirationDate' },
          { path: 'item.additionalImages.urlExpirationDate' },
          {
            path: 'item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
          },
          {
            path: 'item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
          },
          { path: 'item.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.CreateItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.image.urlExpirationDate' },
              { path: 'item.additionalImages.urlExpirationDate' },
              {
                path: 'item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'item.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createItem;
}

/**
 * > **Note:** The Items API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple items at once.
 */
export function bulkCreateItems(payload: object): RequestOptionsFactory<any> {
  function __bulkCreateItems({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'items.createdDate' },
          { path: 'items.updatedDate' },
          { path: 'items.image.urlExpirationDate' },
          { path: 'items.additionalImages.urlExpirationDate' },
          {
            path: 'items.orderSettings.availability.timestampRangesOptions.ranges.startTime',
          },
          {
            path: 'items.orderSettings.availability.timestampRangesOptions.ranges.endTime',
          },
          { path: 'items.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.BulkCreateItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/bulk/items/create',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.image.urlExpirationDate' },
              { path: 'results.item.additionalImages.urlExpirationDate' },
              {
                path: 'results.item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'results.item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'results.item.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkCreateItems;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves an item by ID.
 */
export function getItem(payload: object): RequestOptionsFactory<any> {
  function __getItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.GetItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.image.urlExpirationDate' },
              { path: 'item.additionalImages.urlExpirationDate' },
              {
                path: 'item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'item.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getItem;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 items.
 */
export function listItems(payload: object): RequestOptionsFactory<any> {
  function __listItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.ListItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'items.createdDate' },
              { path: 'items.updatedDate' },
              { path: 'items.image.urlExpirationDate' },
              { path: 'items.additionalImages.urlExpirationDate' },
              {
                path: 'items.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'items.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'items.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listItems;
}

/**
 * Creates a query to retrieve a list of items.
 *
 * The `queryItems()` function builds a query to retrieve a list of items and returns a `ItemsQueryBuilder` object.
 *
 * The returned object contains the query definition, which is used to run the query using the [`find()`](/items/items-query-builder/find) function.
 *
 * You can refine the query by chaining `ItemsQueryBuilder` functions onto the query. `ItemsQueryBuilder` functions enable you to filter, sort, and control the results that `queryItems()` returns.
 *
 * `queryItems()` runs with the following `ItemsQueryBuilder` defaults, which you can override:
 *
 * * [`limit(500)`](/items/items-query-builder/limit)
 *
 * The following `ItemsQueryBuilder` functions are supported for `queryItems()`. For a full description of the item object, see the object returned for the [`items`](/items/items-query-result/items) property in `ItemsQueryResult`.
 */
export function queryItems(payload: object): RequestOptionsFactory<any> {
  function __queryItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.QueryItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'items.createdDate' },
              { path: 'items.updatedDate' },
              { path: 'items.image.urlExpirationDate' },
              { path: 'items.additionalImages.urlExpirationDate' },
              {
                path: 'items.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'items.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'items.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryItems;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of items given the provided filtering, paging, and sorting.
 *
 * ## Defaults
 * Search Items has the following default settings, which you can override:
 *
 * - Sorted by `createdDate` in ascending order.
 * - `paging.limit` set to `500`.
 * - `paging.offset` set to `0`.
 */
export function searchItems(payload: object): RequestOptionsFactory<any> {
  function __searchItems({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'search.aggregations.range.buckets.from' },
          { path: 'search.aggregations.range.buckets.to' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.SearchItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items/search',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'items.createdDate' },
              { path: 'items.updatedDate' },
              { path: 'items.image.urlExpirationDate' },
              { path: 'items.additionalImages.urlExpirationDate' },
              {
                path: 'items.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'items.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'items.externalReferenceInfo.lastSyncDate' },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'aggregationData.results.ranges.results.from' },
              { path: 'aggregationData.results.ranges.results.to' },
              { path: 'aggregationData.results.scalar.value' },
            ],
          },
        ]),
      fallback: [
        {
          method: 'POST' as any,
          url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
            protoPath: '/v1/items/search',
            data: serializedData,
            host,
          }),
          data: serializedData,
        },
      ],
    };

    return metadata;
  }

  return __searchItems;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves the number of items that match a specified filter.
 *
 * If a filter isn't passed in the request, the endpoint returns the count of all items.
 */
export function countItems(payload: object): RequestOptionsFactory<any> {
  function __countItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.CountItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items/count',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __countItems;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates an item.
 *
 * To update multiple items at once, use [Bulk Update Item](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item/bulk-update-item)
 *
 * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating the item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
 */
export function updateItem(payload: object): RequestOptionsFactory<any> {
  function __updateItem({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'item.createdDate' },
          { path: 'item.updatedDate' },
          { path: 'item.image.urlExpirationDate' },
          { path: 'item.additionalImages.urlExpirationDate' },
          {
            path: 'item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
          },
          {
            path: 'item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
          },
          { path: 'item.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.UpdateItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items/{item.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.image.urlExpirationDate' },
              { path: 'item.additionalImages.urlExpirationDate' },
              {
                path: 'item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'item.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateItem;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates up to 100 multiple items at once.
 *
 * Each time an item is updated, its revision increments by 1. The existing revision must be included when updating item. This ensures you're working with the latest item information, and it prevents unintended overwrites.
 */
export function bulkUpdateItem(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateItem({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'items.mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'items.item.createdDate' },
          { path: 'items.item.updatedDate' },
          { path: 'items.item.image.urlExpirationDate' },
          { path: 'items.item.additionalImages.urlExpirationDate' },
          {
            path: 'items.item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
          },
          {
            path: 'items.item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
          },
          { path: 'items.item.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.BulkUpdateItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/bulk/items/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              { path: 'results.item.image.urlExpirationDate' },
              { path: 'results.item.additionalImages.urlExpirationDate' },
              {
                path: 'results.item.orderSettings.availability.timestampRangesOptions.ranges.startTime',
              },
              {
                path: 'results.item.orderSettings.availability.timestampRangesOptions.ranges.endTime',
              },
              { path: 'results.item.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateItem;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes an item.
 */
export function deleteItem(payload: object): RequestOptionsFactory<any> {
  function __deleteItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.DeleteItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteItem;
}

/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes multiple items at once.
 */
export function bulkDeleteItems(payload: object): RequestOptionsFactory<any> {
  function __bulkDeleteItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.item',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.BulkDeleteItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusItemV1RestaurantsMenusItemUrl({
        protoPath: '/v1/bulk/items/delete',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __bulkDeleteItems;
}
